import { SimpleEvents } from '../../utils/events'
import { IdentityEvent, IIdentityEvent } from '../common/events/identity'

export interface IWindow extends Window {
    mParticle: any
}

declare let window: IWindow

export class ConsentBannerService extends SimpleEvents {
    public static DOM = {
        className: {
            banner: 'consent__banner',
            button: 'consent__button',
            variant: 'consent__banner--with-article-limit'
        }
    }
    public consentState: any // window.mParticle.Identity.getCurrentUser.getConsentState
    public articleLimitAlert = false

    /**
     * get banner ok button HTML El
     */
    public get bannerButton(): HTMLElement {
        return document.querySelector(`.${ConsentBannerService.DOM.className.button}`)
    }

    /**
     * get banner HTML El
     */
    public get banner(): HTMLElement {
        return document.querySelector(`.${ConsentBannerService.DOM.className.banner}`)
    }

    /**
     * checks consent state for any given consent
     */
    public get checkConsentGiven(): boolean {
        if( !this.consentState ||
            !this.consentState.getGDPRConsentState().ad_targeting ||
            !this.consentState.getGDPRConsentState().personalization ||
            !this.consentState.getCCPAConsentState()) {
            return false
        } else {
            console.debug('CONSENT: already given')
            return true
        }
    }

    /**
     * Stores consent state and registers listener(s).
     */
    public initialize() {
        // listening for mParticle Identity availability
        addEventListener(IdentityEvent.PROVIDER_ID_ASSIGNED, (e: IIdentityEvent) => {
            if (e.detail.mpId) {
                this.consentState = window.mParticle.Identity.getCurrentUser().getConsentState()

                // if consent hasn't been given init banner
                if (!this.checkConsentGiven) {
                    this.showBanner()
                    this.listenForConsent()
                }
            }
        })

        addEventListener('articleLimitAlertEvent', (event: CustomEvent) => {
            if (event && event.detail) {
                this.articleLimitAlert = event.detail.limit ? true : false
                this.labelBannerDisplayVariant()
            }
        })
    }

    /**
     * add click listener to banner button
     */
    public listenForConsent(): void {
        if (this.bannerButton) {
            this.bannerButton.addEventListener('click', this.handleButton.bind(this))
        }
    }

    /**
     * remove click listener from banner button
     */
    public stoplisteningForConsent(): void {
        if (this.bannerButton) {
            this.bannerButton.removeEventListener('click', this.handleButton.bind(this))
        }
    }

    /**
     * handle banner button consent click event
     */
    public handleButton(): void {
        this.generateConsentState()
        this.hideBanner()
        this.stoplisteningForConsent()
    }

    /**
     * remove attr hidden from banner to show
     */
    public showBanner(): void {
        if (this.banner) {
            this.banner.removeAttribute('hidden')
        }
    }

    /**
     * add attr hidden to banner to hide
     */
    public hideBanner(): void {
        if (this.banner) {
            this.banner.setAttribute('hidden', '')
        }
    }

    /**
     * if another popup exists, add a class to label the variant
     * for adjusting the display in that case
     */
    public labelBannerDisplayVariant(): void {
        if (this.articleLimitAlert) {
            this.banner.classList.add(ConsentBannerService.DOM.className.variant)
        } else {
            this.banner.classList.remove(ConsentBannerService.DOM.className.variant)
        }
    }

    /**
     * create consent state information with mparticle functions
     * and save on the mparticle user
     */
    public generateConsentState(): void {
        const now = Date.now()
        const location = window.location.href
        const bannerName = 'FEM_banner_notification'
        const newConsentState = window.mParticle.Consent.createConsentState()
        const user = window.mParticle.Identity.getCurrentUser()

        // create consent data
        const adTargeting =  window.mParticle.Consent.createGDPRConsent(
            true, // Consented
            now, // Timestamp
            bannerName, // Document
            location // Location
        )

        const personalization = window.mParticle.Consent.createGDPRConsent(
            true, // Consented
            now, // Timestamp
            bannerName, // Document
            location // Location
        )

        const ccpa = window.mParticle.Consent.createCCPAConsent(
            true, // true represents a "data sale opt-out", false represents the user declining a "data sale opt-out"
            now, // Timestamp
            bannerName, // Document
            location // Location
        )

        // build new consent state
        newConsentState.addGDPRConsentState('ad_targeting', adTargeting)
        newConsentState.addGDPRConsentState('personalization', personalization)
        newConsentState.setCCPAConsentState(ccpa)
        // save to user
        user.setConsentState(newConsentState)
        console.debug('CONSENT: created for user')
    }
}
